// extracted by mini-css-extract-plugin
module.exports = {"container":"partials-home-cards-container","card":"partials-home-cards-card"};